import React from 'react'
import { createPortal } from 'react-dom'

// import is from '../../utils/is'
import styles from './modal.module.css'

const Modal = (props) => {
  const { children, onClose, open, closeButton = true } = props

  return open
    ? createPortal(
        <aside className={styles.modal}>
          {closeButton && (
            <button onClick={onClose} className={styles.close}>
              &times;
            </button>
          )}
          {children}
        </aside>,
        document.body,
      )
    : null
}

export default Modal
